import { OnDestroy } from '@angular/core';
import { ClosableModal } from '../../modules/modal/closable-modal';
import { HttpErrorResponse } from '@angular/common/http';
import { Subscription } from 'rxjs';

import { NotificationService } from '../../services';
import { ModalService } from '../../modules/modal/modal.service';

// import { TranslationConstants } from '../../constants/translation';

export class ClosableModalWithErrorResponseModel<T> extends ClosableModal implements OnDestroy {
  validationErrors: T;
  responseErrors: string[] = [];
  subscriptions: Subscription[] = [];

  constructor(
    protected notificationService: NotificationService,
    protected modalService: ModalService
  ) {
    super(modalService);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription: Subscription) => { subscription.unsubscribe(); });
  }

  public resetErrors(): void {
    this.validationErrors = null;
    this.responseErrors = [];
  }

  protected listenForErrorMessages(): void {
    this.subscriptions.push(
      this.notificationService.notification$.subscribe((message) => {
        this.handleErrors(message);
      })
    );
  }

  protected handleErrors(response: HttpErrorResponse): void {
    this.isSaveDisabled = false;

    if (response.status === 422) {
      this.validationErrors = response.error.errors;
    }
    // } else if (response.status === 400) {
    //   this.responseErrors.push(response.error.errors.global);
    // } else {
    //   this.responseErrors.push(TranslationConstants.GLOBAL_SERVER_ERROR);
    // }
  }
}

// used in cases where we don't have validation errors model defined and we override handleErrors method
export class ClosableModalWithErrorResponse extends ClosableModalWithErrorResponseModel<any> {
  constructor(
    protected notificationService: NotificationService,
    protected modalService: ModalService
  ) {
    super(notificationService, modalService);
  }
}
